import type { AssetCategoryType, AssetTypeDataType } from './types';

export const createCategories = (
  categories
): Record<string, AssetCategoryType> =>
  categories.reduce(
    (categoriesObj, category) => ({
      ...categoriesObj,
      [category.name]: category,
    }),
    {}
  );

export const createInitAssetTypesDataMap = (
  assetTypes
): Record<string, AssetTypeDataType> =>
  assetTypes.reduce(
    (dataMap, assetType) => ({
      ...dataMap,
      [assetType.code]: {
        ...assetType,
        categories: {},
        isLoading: false,
      },
    }),
    {}
  ) as Record<string, AssetTypeDataType>;
